function initialize(component, config) {
    if (!(config === null || config === void 0 ? void 0 : config.elements))
        return console.warn("Module init: Please check that the provided selector and module-class exists");
    if (component instanceof Function)
        config.elements.forEach(function (element) { return component(element); });
}
export { initialize };
